import { useDebounceCallback } from '@data-products-and-ai/react-components';
import { useState } from 'react';

interface UseSearchOptions {
  initialQuery?: string;
  debounceMs?: number;
}

export const useSearch = ({
  initialQuery = '',
  debounceMs = 500,
}: UseSearchOptions = {}) => {
  const [query, setQuery] = useState(initialQuery);
  const [debouncedQuery, setDebouncedQuery] = useState(initialQuery);

  const debouncedSetQuery = useDebounceCallback((value: string) => {
    setDebouncedQuery(value);
  }, debounceMs);

  const handleSearch = (value: string) => {
    setQuery(value);
    debouncedSetQuery(value);
  };

  return {
    query,
    debouncedQuery,
    handleSearch,
  };
};
